import {
  createThemes,
  DEFAULT_PALETTE,
  DEFAULT_SUBDUED_PALETTE,
} from '@bsky.app/alf'

/*
 * Batesky orange rebrand. Upstream ships an explicit blue `primary_*` ramp in
 * `@bsky.app/alf`'s DEFAULT_PALETTE / DEFAULT_SUBDUED_PALETTE. We override only
 * the `primary_*` scale with an orange ramp anchored on the Batesky brand hex
 * #FD7C21 (primary_500). The ramp preserves upstream's per-stop lightness so
 * contrast/legibility behavior is unchanged; only the hue moves blue -> orange.
 * Everything else (contrast/positive/negative) is inherited from upstream.
 */
const BATESKY_PRIMARY = {
  primary_25: '#FFF9F5',
  primary_50: '#FFF0E5',
  primary_100: '#FFE1CC',
  primary_200: '#FFCCA8',
  primary_300: '#FFAE75',
  primary_400: '#FF9042',
  primary_500: '#FD7C21',
  primary_600: '#D15905',
  primary_700: '#A3490A',
  primary_800: '#7D3B0D',
  primary_900: '#552A0C',
  primary_950: '#3C1F0B',
  primary_975: '#2A1709',
}

const BATESKY_SUBDUED_PRIMARY = {
  primary_25: '#FFF9F5',
  primary_50: '#FFF3EB',
  primary_100: '#FFE7D6',
  primary_200: '#FFCFAD',
  primary_300: '#FFB580',
  primary_400: '#FF974D',
  primary_500: '#FD7311',
  primary_600: '#E46002',
  primary_700: '#BA5208',
  primary_800: '#92430C',
  primary_900: '#69330D',
  primary_950: '#4F280C',
  primary_975: '#3D200B',
}

const DEFAULT_THEMES = createThemes({
  defaultPalette: {...DEFAULT_PALETTE, ...BATESKY_PRIMARY},
  subduedPalette: {...DEFAULT_SUBDUED_PALETTE, ...BATESKY_SUBDUED_PRIMARY},
})

export const themes = {
  lightPalette: DEFAULT_THEMES.light.palette,
  darkPalette: DEFAULT_THEMES.dark.palette,
  dimPalette: DEFAULT_THEMES.dim.palette,
  light: DEFAULT_THEMES.light,
  dark: DEFAULT_THEMES.dark,
  dim: DEFAULT_THEMES.dim,
}

/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const lightPalette = DEFAULT_THEMES.light.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const darkPalette = DEFAULT_THEMES.dark.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const dimPalette = DEFAULT_THEMES.dim.palette
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const light = DEFAULT_THEMES.light
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dark = DEFAULT_THEMES.dark
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dim = DEFAULT_THEMES.dim
